// extracted by mini-css-extract-plugin
export default {"sectionItemStyle":"FullUsersListItem_sectionItemStyle__mx5hn","textBackStyle":"FullUsersListItem_textBackStyle__yr0eQ","textStyle":"FullUsersListItem_textStyle__6k9C3"};